import React from 'react';
import { useEffect, useRef } from 'react';
import { useVoiceoverContext } from '../../context/VoiceoverContext';

const VoiceoverPlayer = ({ currentSeconds, mainVolume, playing, playbackRate }) => {
  const { voiceovers, isVoiceoverOpened, isNewVoiceoverSeekValue, changeIsNewVoiceoverSeekValue } = useVoiceoverContext();

  const audioRef = useRef(null);

  const currentVoiceover =
    voiceovers?.find(
      ({ trimStartOffset, trimEndOffset, storyOffset }) =>
        storyOffset + trimStartOffset <= currentSeconds && storyOffset + trimEndOffset >= currentSeconds
    ) || {};

  const playAudio = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  const pauseAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
    }
  };

  const resetAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
  };

  const handleUpdateVolume = () => {
    if (audioRef.current) {
      const value = currentVoiceover?.volume;
      if (value >= 0) {
        audioRef.current.volume = value;
      }
    }
  };

  const updateAudioCurrentTime = () => {
    if (audioRef.current) {
      const result = currentSeconds - currentVoiceover?.storyOffset;
      if (result >= 0) {
        audioRef.current.currentTime = result / 1000;
      }
    }
  };

  useEffect(() => {
    if (isVoiceoverOpened) {
      handleUpdateVolume();
    }
  }, [mainVolume, currentVoiceover?.volume, isVoiceoverOpened]);

  useEffect(() => {
    if (isNewVoiceoverSeekValue) {
      changeIsNewVoiceoverSeekValue(false);

      updateAudioCurrentTime();
    }
  }, [isNewVoiceoverSeekValue]);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.playbackRate = playbackRate;
    }
  }, [playbackRate]);

  useEffect(() => {
    if (playing) {
      playAudio();
    } else {
      pauseAudio();
    }
  }, [playing]);

  useEffect(() => {
    if (currentVoiceover?.path && isVoiceoverOpened) {
      const newAudio = new Audio(currentVoiceover?.path);
      const currentTime = currentSeconds - currentVoiceover?.storyOffset;

      newAudio.addEventListener('loadedmetadata', () => {
        newAudio.currentTime = currentTime < 0 ? 0 : currentTime / 1000;
        newAudio.playbackRate = playbackRate;

        const value = currentVoiceover?.volume;
        if (value >= 0) {
          newAudio.volume = value;
        }
      });

      newAudio.load();

      if (playing) {
        newAudio.play();
      }

      audioRef.current = newAudio;
    } else {
      resetAudio();
    }

    return () => resetAudio();
  }, [currentVoiceover?.path]);

  return <></>;
};

export default VoiceoverPlayer;
